import moment from "moment";

import { useAppSelector } from "@assessment/store/store";
import type { RootState } from "@assessment/store/store";
import { ParseDateString } from "@lxp-app/utils/parse-date-string/parseDateString";
import { useTranslation } from "react-i18next";

import scheduleNotStarted from "../../../../../../public/images/access-screens/scheduleNotStarted.svg";

const ScheduleNotStarted = ({
  orgBasedFeatureName = "assessment"
}: {
  orgBasedFeatureName?: string;
}) => {
  const { t } = useTranslation();

  const capitalizedFeatureName = orgBasedFeatureName
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  const startTime = useAppSelector(
    (state) => state.AssessmentSlice.preAssessmentData?.startTime
  );
  const title = useAppSelector(
    (state) => state.AssessmentSlice.preAssessmentData?.title
  );
  const user = useAppSelector((state: RootState) => state.UserInfoSlice);
  const userTZ = user.profile?.preferences?.timezone || "UTC";

  return (
    <div className="flex flex-col justify-center items-center space-y-5 text-center w-full py-10">
      <img
        src={scheduleNotStarted}
        alt={t("assessment.accessScreens.scheduleNotStarted.alt")}
        className="w-[300px] h-[300px] lg:w-[500px] lg:h-[500px] object-cover"
      />
      <div className="max-w-[800px]">
        <h1 className="text-2xl text-primary font-bold">
          {t("assessment.accessScreens.scheduleNotStarted.title", {
            featureName: capitalizedFeatureName
          })}
        </h1>
        <p className="mt-5 text-primary text-base">
          {t("assessment.accessScreens.scheduleNotStarted.scheduledPrefix")}{" "}
          <span className="font-bold">{title}</span>{" "}
          {t("assessment.accessScreens.scheduleNotStarted.scheduledOn")}{" "}
          <span className="font-bold">
            {ParseDateString({
              timeString: startTime,
              timezone: userTZ,
              userTZ: userTZ,
              showAbbreviation: true
            })}
          </span>
          .
        </p>
        <p className="text-primary text-base">
          {t("assessment.accessScreens.scheduleNotStarted.checkBack", {
            time: moment(startTime).fromNow(true)
          })}
        </p>
      </div>
    </div>
  );
};

export default ScheduleNotStarted;
